<template>
  <div
    class="flex max-w-min items-center rounded px-2 py-1 text-xs font-semibold"
    :class="type.style"
    :content="type.tooltip"
    v-tippy="{ arrow: true, theme: 'green' }"
  >
    <span class="uppercase">
      {{ longName ? type.long : type.short }}
    </span>
    <span class="sr-only">
      {{ type.tooltip }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    accountType: {
      type: String,
      required: true,
      validator: (val) => {
        return ["DEMO", "PRD", "CONTEST"].includes(val);
      },
    },
    longName: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    type() {
      const types = {
        DEMO: {
          short: "D",
          long: "Demo",
          tooltip: "Conta Demo",
          style: "bg-gray-500 text-gray-200",
        },
        PRD: {
          short: "P",
          long: "Prod",
          tooltip: "Conta Produção",
          style: "bg-ontick-blue-900 text-ontick-blue-500",
        },
        CONTEST: {
          short: "C",
          long: "Contest",
          tooltip: "Conta competição",
          style: "bg-ontick-yellow-900 text-ontick-yellow-500",
        },
      };
      return types[this.accountType];
    },
  },
};
</script>

<style></style>
